import { render, staticRenderFns } from "./page4Mobile.vue?vue&type=template&id=21415162&scoped=true&"
import script from "./page4Mobile.vue?vue&type=script&lang=js&"
export * from "./page4Mobile.vue?vue&type=script&lang=js&"
import style0 from "./page4Mobile.vue?vue&type=style&index=0&id=21415162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21415162",
  null
  
)

export default component.exports